var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-tip-mask",on:{"click":_vm.cancel}},[_c('div',{staticClass:"light-tip-dialog",on:{"click":function (e) { return e.stopPropagation(); }}},[_c({ render: _vm.message },{ref:"comp",tag:"component"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8c0e1ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/LightTip.vue
// module id = null
// module chunks = 